import { COLORS } from '@/constants';
import styled from 'styled-components';

export const AsideContainer = styled.aside`
  max-width: 368px;
  width: 100%;
  position: sticky;
  top: 100px;
  align-self: flex-start;

  @media (max-width: 920px) {
    max-width: 100%;
    position: static;
  }
`;

export const AsideBox = styled.div`
  max-width: 368px;
  padding: 20px 24px;
  background: ${COLORS['neutral/50']};
  border-radius: 10px;
  border: 1px solid ${COLORS['neutral/300']};
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 920px) {
    max-width: 100%;
  }
`;
